<h1 class="visually-hidden">Judiciary Payment Portal</h1>
<div class="home-container d-flex flex-column gap-5" *ngIf="announcements.length > 0">
  <div class="d-flex flex-column gap-4">
    <div class="accordion" *ngIf="!isTerminal">
      <div class="card">
        <div class="card-header">
          <button
            class="btn btn-link"
            data-bs-toggle="collapse"
            data-bs-target="#accordion-content"
            aria-expanded="true"
            aria-controls="accordion-content"
            title="Toggle Accordion"
          >
            <span>Announcements</span>
            <span class="badge bg-primary">{{ announcements.length }}</span>
          </button>
        </div>

        <div id="accordion-content" class="collapse show">
          <div class="card-body">

            <!-- Carousel Display Mode -->
            <div *ngIf="displayMode === displayModes.CAROUSEL">
              <div
                id="section-carousel"
                class="carousel slide"
                data-bs-ride="carousel"
                data-bs-interval="5000"
                data-bs-pause="hover"
              >
                <div class="carousel-indicators">
                  <button
                    *ngFor="let announcement of announcements; let idx = index"
                    type="button"
                    data-bs-target="#section-carousel"
                    [attr.data-bs-slide-to]="idx"
                    [class.active]="idx === 0"
                    [attr.aria-current]="idx === 0 ? 'true' : null"
                    [attr.aria-label]="'Slide ' + (idx + 1)"
                  ></button>
                </div>

                <div class="carousel-inner">
                  <div *ngFor="let announcement of announcements; let idx = index"
                    class="carousel-item"
                    [class.active]="idx === 0"
                  >
                    <div class="carousel-card-content">
                      <span [innerHTML]="getTruncatedMessage(announcement.message)"></span>
                      <a *ngIf="shouldShowReadMore(announcement.message)"
                        href="#"
                        (click)="openAnnouncementModal(announcement)">Read More</a>
                    </div>
                  </div>
                </div>

                <button
                  class="btn carousel-control-prev"
                  data-bs-target="#section-carousel"
                  data-bs-slide="prev"
                  title="Show Previous Slide"
                >
                  <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                  <span class="visually-hidden">Previous</span>
                </button>
                <button
                  class="btn carousel-control-next"
                  data-bs-target="#section-carousel"
                  data-bs-slide="next"
                  title="Show Next Slide"
                >
                  <span class="carousel-control-next-icon" aria-hidden="true"></span>
                  <span class="visually-hidden">Next</span>
                </button>
              </div>
            </div>

            <!-- Sequential Display Mode -->
            <div *ngIf="displayMode === displayModes.SEQUENTIAL">
              <div class="card">
                <div class="card-body p-3">
                  <ol class="announcement-list pl-3 m-0">
                    <li *ngFor="let announcement of announcements" class="mb-1">
                      <span [innerHTML]="getTruncatedMessage(announcement.message)"></span>
                      <a
                        *ngIf="shouldShowReadMore(announcement.message)"
                        href="#"
                        (click)="openAnnouncementModal(announcement)"
                      >Read More</a>
                    </li>
                  </ol>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="errorMessage" class="alert alert-danger d-flex align-items-start gap-2" role="alert">
    <span style="font-size: 1.5rem; line-height: 1;">&#10006;</span>
    <div>
      <strong>Error Message:</strong><br />
      {{ errorMessage }}
    </div>
  </div>


  <!-- Full Announcement Modal -->
  <div class="modal fade" id="announcementModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered modal-fullscreen-sm-down">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Announcement Details</h5>
          <button type="button" class="btn" data-bs-dismiss="modal" aria-label="Close">
            <span style="font-size: 1.5rem;">&times;</span>
          </button>
        </div>
        <!-- Render sanitized HTML here -->
        <div class="modal-body" [innerHTML]="selectedAnnouncement"></div>
      </div>
    </div>
  </div>


  <div
    class="payment-container gap-2 gap-sm-4 d-flex flex-row justify-content-center"
    *ngIf="chunkedCourtDepositModules.length == 0 && chunkedCourtPaymentModules.length == 0">
    <div class="card has-icon" (click)="navigateToCourtPayment(null)" (keydown)="handleDropdownKey($event)">
      <div class="card-body">
        <div class="card-icon mb-4">
          <span><i class="fal fa-briefcase"></i></span>
        </div>
        <h4 class="card-title">COURT PAYMENT</h4>
      </div>
    </div>

    <div class="card has-icon" data-bs-toggle="modal" data-bs-target="#confirmDialogDeposit">
      <div class="card-body">
        <div class="card-icon mb-4">
          <span><i class="fal fa-briefcase"></i></span>
        </div>
        <h4 class="card-title">COURT DEPOSIT</h4>
      </div>
    </div>
  </div>
</div>

<div class="home-container" *ngIf="chunkedCourtDepositModules.length > 0 && chunkedCourtPaymentModules.length > 0">

  <app-error-banner
    *ngIf="errorMessage"
    [message]="errorMessage">
  </app-error-banner>

  <div class="row">
    <!-- Left Section: Court Payment -->
    <div class="col-12 col-md-6 mb-4">
      <div class="card shadow-sm">
        <div class="card-body">
          <h4 class="section-title p-3">Court Payments</h4>
          <div class="payment-container d-flex flex-column gap-3">
            <div class="d-flex flex-wrap justify-content-center gap-2 gap-sm-4" *ngFor="let row of chunkedCourtPaymentModules">
              <div class="card has-icon" *ngFor="let module of row" (click)="handleCourtPaymentClick(module)" (keydown)="handleDropdownKey($event)">
                <div class="card-body btn-equal-width">
                  <div class="card-icon mb-4">
                    <span *ngIf="!hasImage(module)">
                      <i class="fal fa-briefcase"></i>
                    </span>
                    <img
                      *ngIf="hasImage(module)"
                      [src]="getImageSrc(module)"
                      [alt]="module.title"
                      class="card-image"
                      loading="lazy"
                    />
                  </div>
                  <h4 class="card-title">{{ module.title }}</h4>
                </div>
              </div>
            </div>
          </div>
          <div class="text-center mt-4" style="color: var(--primary); font-weight: bold;">
            Scan QR Code in PAC/Invoice to retrieve Payment Information
          </div>
        </div>
      </div>
    </div>

    <!-- Right Section: Court Deposit -->
    <div class="col-12 col-md-6 mb-4">
      <div class="card shadow-sm">
        <div class="card-body">
          <h4 class="section-title p-3">Court Deposits</h4>
          <div class="payment-container d-flex flex-column gap-3">
            <div class="d-flex flex-wrap justify-content-center gap-2 gap-sm-4" *ngFor="let row of chunkedCourtDepositModules">
              <div class="card has-icon" data-bs-toggle="modal" data-bs-target="#confirmDialogDeposit" *ngFor="let module of row" (click)="selectCourtDepositModule(module)" (keydown)="handleDropdownKey($event)">
                <div class="card-body btn-equal-width">
                  <div class="card-icon mb-4">
                    <span *ngIf="!hasImage(module)">
                      <i class="fal fa-briefcase"></i>
                    </span>
                      <img
                        *ngIf="hasImage(module)"
                        [src]="getImageSrc(module)"
                        [alt]="module.title"
                        class="card-image"
                        loading="lazy"
                      />
                  </div>
                  <h4 class="card-title">{{ module.title }}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="confirmDialogDeposit" tabindex="-1" aria-labelledby="confirmDialogDeposit" aria-hidden="true" style="display: none;">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="jdsModalLabe3l">Important Note</h5>
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close"> <i aria-hidden="true" class="fal fa-close"></i> </button>
      </div>
      <div class="modal-body">This is for Court Deposits related payment only. It is not applicable for Court Fees, Court Fines, Bail/Bond, Invoice payments.</div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-primary font-weight-bold" data-bs-dismiss="modal">Cancel</button>
        <button type="button" class="btn btn-primary font-weight-bold" (click)="navigateToCourtDeposit()" data-bs-dismiss="modal"><i class="fa-solid fa-up-right-from-square icons"></i>&nbsp;Proceed</button>
      </div>
    </div>
  </div>
</div>
